"use client";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { format, formatDistanceToNow } from "date-fns";
import { AlertCircle, AudioWaveform, Ban, Check, CheckCircle2, ChevronDown, ChevronUp, Clock, Coins, Copy, Eye, ExternalLink, Globe, Info, Loader2, Link as LinkIcon, Package, Plug, RefreshCw, Sparkles, TrendingDown, TriangleAlert, Zap } from "lucide-react";
import prettyBytes from "pretty-bytes";
import { useState } from "react";
import { Badge } from "./ui/badge.js";
import { Button } from "./ui/button.js";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog.js";
import { Tooltip, TooltipContent, TooltipTrigger } from "./ui/tooltip.js";
import { formatServiceTierMultiplier, getServiceTier } from "@llmgateway/models";
import { defaultLogCardCopy } from "./log-card-copy.js";
function formatDuration(ms) {
  if (ms < 1000) {
    return "".concat(ms, "ms");
  }
  return "".concat((ms / 1000).toFixed(2), "s");
}
function formatApiKeyHash(hash) {
  return hash.slice(0, 7);
}
function copyToClipboard(text) {
  void navigator.clipboard.writeText(text);
}
function CopyMetadataButton(_a) {
  var value = _a.value,
    label = _a.label,
    _b = _a.copiedLabel,
    copiedLabel = _b === void 0 ? defaultLogCardCopy.copied : _b;
  var _c = useState(false),
    copied = _c[0],
    setCopied = _c[1];
  return _jsx("button", {
    type: "button",
    "aria-label": label,
    title: copied ? copiedLabel : label,
    className: "text-muted-foreground hover:text-foreground",
    onClick: function () {
      copyToClipboard(value);
      setCopied(true);
      setTimeout(function () {
        return setCopied(false);
      }, 1500);
    },
    children: copied ? _jsx(Check, {
      className: "h-3 w-3"
    }) : _jsx(Copy, {
      className: "h-3 w-3"
    })
  });
}
function RelatedResourceValue(_a) {
  var id = _a.id,
    name = _a.name,
    copyLabel = _a.copyLabel,
    _b = _a.copiedLabel,
    copiedLabel = _b === void 0 ? defaultLogCardCopy.copied : _b,
    showCopyButton = _a.showCopyButton;
  if (!id) {
    return _jsx("span", {
      className: "text-muted-foreground",
      children: "\u2014"
    });
  }
  var displayName = name === null || name === void 0 ? void 0 : name.trim();
  return _jsxs("span", {
    className: "min-w-0 space-y-0.5 break-all",
    children: [displayName && _jsx("span", {
      className: "block break-words",
      children: displayName
    }), _jsxs("span", {
      className: "flex min-w-0 items-center gap-1.5 font-mono text-xs text-muted-foreground break-all",
      children: [_jsx("span", {
        className: "min-w-0 break-all",
        children: displayName ? "ID: ".concat(id) : id
      }), showCopyButton && _jsx(CopyMetadataButton, {
        value: id,
        label: copyLabel,
        copiedLabel: copiedLabel
      })]
    })]
  });
}
function PlainIdValue(_a) {
  var id = _a.id;
  return _jsx("span", {
    className: "min-w-0 space-y-0.5",
    children: _jsx("span", {
      className: "block font-mono text-xs break-all",
      children: id !== null && id !== void 0 ? id : "—"
    })
  });
}
function renderParams(obj, depth) {
  if (depth === void 0) {
    depth = 0;
  }
  return Object.entries(obj).flatMap(function (_a) {
    var key = _a[0],
      value = _a[1];
    if (value === null || value === undefined) {
      return [];
    }
    if (typeof value === "object" && !Array.isArray(value)) {
      return renderParams(value, depth + 1);
    }
    var formattedKey = key.replace(/_/g, " ").replace(/\b\w/g, function (l) {
      return l.toUpperCase();
    });
    return [_jsxs("div", {
      className: "contents",
      children: [_jsx("div", {
        className: "text-muted-foreground",
        children: formattedKey
      }), _jsx("div", {
        children: Array.isArray(value) ? value.join(", ") : String(value)
      })]
    }, key)];
  });
}
function DefaultLink(_a) {
  var href = _a.href,
    className = _a.className,
    children = _a.children;
  return _jsx("a", {
    href: href,
    className: className,
    children: children
  });
}
export function LogCard(_a) {
  var _this = this;
  var _b, _c, _d_0, _e, _f, _g, _h, _j, _k, _l, _m, _o;
  var log = _a.log,
    getDetailUrl = _a.getDetailUrl,
    getRetriedUrl = _a.getRetriedUrl,
    _p = _a.renderLink,
    LinkComponent = _p === void 0 ? DefaultLink : _p,
    _q = _a.showCopyButtons,
    showCopyButtons = _q === void 0 ? false : _q,
    _r = _a.showLogId,
    showLogId = _r === void 0 ? false : _r,
    _s = _a.isUserFacing,
    isUserFacing = _s === void 0 ? false : _s,
    fetchImageContent = _a.fetchImageContent,
    fetchInputImages = _a.fetchInputImages,
    _t = _a.copy,
    copy = _t === void 0 ? defaultLogCardCopy : _t,
    dateFnsLocale = _a.dateFnsLocale;
  var routingMetadata = log.routingMetadata;
  var errorDetails = log.errorDetails;
  var pluginResults = log.pluginResults;
  var toolResults = log.toolResults;
  var tools = log.tools;
  var toolChoice = log.toolChoice;
  var messages = log.messages;
  var responseFormat = log.responseFormat;
  var params = log.params;
  var customHeaders = log.customHeaders;
  var imageConfig = params === null || params === void 0 ? void 0 : params.image_config;
  var remainingParams = params ? Object.fromEntries(Object.entries(params).filter(function (_a) {
    var key = _a[0];
    return key !== "image_config";
  })) : undefined;
  var retentionEnabled = log.dataStorageCost !== null && log.dataStorageCost !== undefined && Number(log.dataStorageCost) > 0;
  var _u = useState(false),
    isExpanded = _u[0],
    setIsExpanded = _u[1];
  var _v = useState(false),
    imagePreviewOpen = _v[0],
    setImagePreviewOpen = _v[1];
  var _w = useState([]),
    imagePreviewSrcs = _w[0],
    setImagePreviewSrcs = _w[1];
  var _x = useState(copy.generatedImageTitle),
    imagePreviewTitle = _x[0],
    setImagePreviewTitle = _x[1];
  var _y = useState(false),
    imagePreviewLoading = _y[0],
    setImagePreviewLoading = _y[1];
  var _z = useState(false),
    inputPreviewLoading = _z[0],
    setInputPreviewLoading = _z[1];
  var messagesHaveRedactedInput = messages !== undefined && JSON.stringify(messages).includes("[base64_image_input_redacted]");
  var formattedTime = formatDistanceToNow(new Date(log.createdAt), {
    addSuffix: true,
    locale: dateFnsLocale
  });
  var detailUrl = getDetailUrl === null || getDetailUrl === void 0 ? void 0 : getDetailUrl(log.id);
  var StatusIcon = CheckCircle2;
  var color = "text-green-500";
  var bgColor = "bg-green-100 dark:bg-green-900/30";
  if (log.hasError || log.unifiedFinishReason === "error") {
    StatusIcon = AlertCircle;
    color = "text-red-500";
    bgColor = "bg-red-100 dark:bg-red-900/30";
  } else if (log.unifiedFinishReason === "content_filter") {
    StatusIcon = TriangleAlert;
    color = "text-orange-500";
    bgColor = "bg-orange-100 dark:bg-orange-900/30";
  } else if (log.unifiedFinishReason !== "completed" && log.unifiedFinishReason !== "tool_calls") {
    StatusIcon = AlertCircle;
    color = "text-yellow-500";
    bgColor = "bg-yellow-100 dark:bg-yellow-900/30";
  }
  return _jsxs("div", {
    className: "rounded-lg border bg-card text-card-foreground shadow-sm max-w-full overflow-hidden",
    children: [_jsxs("div", {
      className: "flex items-start gap-4 p-4 ".concat(isExpanded ? "border-b" : ""),
      children: [_jsx("div", {
        className: "mt-0.5 rounded-full p-1 ".concat(bgColor, " shrink-0"),
        children: _jsx(StatusIcon, {
          className: "h-4 w-4 ".concat(color)
        })
      }), _jsxs("div", {
        className: "flex-1 space-y-1 min-w-0",
        children: [_jsxs("div", {
          className: "flex items-start justify-between gap-4",
          children: [_jsxs("div", {
            className: "flex items-center gap-2 flex-1 min-w-0",
            children: [_jsx("p", {
              className: "font-medium break-words max-w-none line-clamp-2",
              children: log.content === "[image_generated]" ? detailUrl ? _jsxs(LinkComponent, {
                href: detailUrl,
                className: "text-blue-600 dark:text-blue-400 hover:underline inline-flex items-center gap-1",
                children: [_jsx(Sparkles, {
                  className: "h-3.5 w-3.5"
                }), copy.imageGeneratedViewDetails]
              }) : _jsxs("span", {
                className: "text-muted-foreground inline-flex items-center gap-1",
                children: [_jsx(Sparkles, {
                  className: "h-3.5 w-3.5"
                }), copy.imageGenerated]
              }) : (_b = log.content) !== null && _b !== void 0 ? _b : log.unifiedFinishReason === "tool_calls" && toolResults ? Array.isArray(toolResults) ? copy.toolCalls(toolResults.map(function (tr) {
                var _a_0, _b_0;
                return (_b_0 = (_a_0 = tr.function) === null || _a_0 === void 0 ? void 0 : _a_0.name) !== null && _b_0 !== void 0 ? _b_0 : copy.unknown;
              }).join(", ")) : copy.toolCallsExecuted : "---"
            }), isUserFacing && !log.content && log.unifiedFinishReason !== "tool_calls" && !log.hasError && !log.canceled && !retentionEnabled && _jsxs(Tooltip, {
              children: [_jsx(TooltipTrigger, {
                asChild: true,
                children: _jsx(Info, {
                  className: "h-4 w-4 text-muted-foreground flex-shrink-0"
                })
              }), _jsx(TooltipContent, {
                children: _jsx("p", {
                  children: copy.retentionTooltip
                })
              })]
            })]
          }), _jsxs("div", {
            className: "flex items-center gap-1.5 flex-shrink-0",
            children: [log.retried && _jsxs(Badge, {
              variant: "outline",
              className: "gap-1 text-amber-600 dark:text-amber-400 border-amber-300 dark:border-amber-700 bg-amber-50 dark:bg-amber-900/30",
              children: [_jsx(RefreshCw, {
                className: "h-3 w-3"
              }), copy.retried]
            }), _jsx(Badge, {
              variant: log.hasError ? "destructive" : log.unifiedFinishReason === "content_filter" ? "destructive" : "default",
              children: copy.finishReason(log.unifiedFinishReason)
            })]
          })]
        }), _jsxs("div", {
          className: "flex flex-wrap items-center gap-x-4 gap-y-1 pt-1 text-sm text-muted-foreground",
          children: [_jsxs("div", {
            className: "flex items-center gap-1",
            children: [_jsx(Package, {
              className: "h-3.5 w-3.5 shrink-0"
            }), _jsx("span", {
              className: "truncate",
              children: log.usedModel === "" ? "—" : log.usedModel
            })]
          }), _jsxs("div", {
            className: "flex items-center gap-1",
            children: [_jsx(Zap, {
              className: "h-3.5 w-3.5 shrink-0"
            }), _jsx("span", {
              children: log.cached ? copy.cacheStatus.fully : log.cachedTokens && Number(log.cachedTokens) > 0 ? copy.cacheStatus.partial : copy.cacheStatus.none
            })]
          }), _jsxs("div", {
            className: "flex items-center gap-1",
            children: [_jsx(Clock, {
              className: "h-3.5 w-3.5 shrink-0"
            }), _jsxs("span", {
              children: [copy.tokenCount(log.totalTokens), log.cachedTokens && Number(log.cachedTokens) > 0 && _jsx("span", {
                className: "ml-1",
                children: copy.cachedTokens(log.cachedTokens)
              })]
            })]
          }), _jsxs("div", {
            className: "flex items-center gap-1",
            children: [_jsx(Clock, {
              className: "h-3.5 w-3.5 shrink-0"
            }), _jsx("span", {
              children: formatDuration((_c = log.duration) !== null && _c !== void 0 ? _c : 0)
            })]
          }), _jsxs(Tooltip, {
            children: [_jsx(TooltipTrigger, {
              asChild: true,
              children: _jsxs("div", {
                className: "flex items-center gap-1",
                children: [_jsx(Coins, {
                  className: "h-3.5 w-3.5 shrink-0"
                }), _jsx("span", {
                  children: log.cost ? "$".concat(log.cost.toFixed(6)) : "$0"
                }), _jsx(Info, {
                  className: "h-3 w-3 text-muted-foreground/50"
                })]
              })
            }), _jsx(TooltipContent, {
              children: _jsxs("p", {
                children: [copy.providerCost, log.usedMode === "api-keys" && (isUserFacing ? copy.notDeductedFromYourBalance : copy.notDeductedFromBalance)]
              })
            })]
          }), log.discount && log.discount !== 1 && _jsxs("div", {
            className: "flex items-center gap-1 text-emerald-600",
            children: [_jsx(TrendingDown, {
              className: "h-3.5 w-3.5 shrink-0"
            }), _jsx("span", {
              children: copy.discountOff((log.discount * 100).toFixed(0))
            })]
          }), log.source && _jsxs("div", {
            className: "flex items-center gap-1",
            children: [_jsx(LinkIcon, {
              className: "h-3.5 w-3.5 shrink-0"
            }), _jsx("span", {
              children: log.source
            })]
          }), log.plugins && log.plugins.length > 0 && _jsxs("div", {
            className: "flex items-center gap-1",
            children: [_jsx(Plug, {
              className: "h-3.5 w-3.5 shrink-0"
            }), _jsx("span", {
              children: copy.pluginCount(log.plugins.length)
            })]
          }), _jsx("span", {
            className: "ml-auto",
            children: formattedTime
          })]
        })]
      }), _jsxs("div", {
        className: "flex items-center gap-1 shrink-0",
        children: [detailUrl && _jsx(Button, {
          asChild: true,
          variant: "ghost",
          size: "sm",
          className: "h-8 w-8 p-0",
          children: _jsxs(LinkComponent, {
            href: detailUrl,
            children: [_jsx(ExternalLink, {
              className: "h-4 w-4"
            }), _jsx("span", {
              className: "sr-only",
              children: copy.viewDetails
            })]
          })
        }), _jsxs(Button, {
          variant: "ghost",
          size: "sm",
          className: "h-8 w-8 p-0",
          onClick: function () {
            return setIsExpanded(!isExpanded);
          },
          children: [isExpanded ? _jsx(ChevronUp, {
            className: "h-4 w-4"
          }) : _jsx(ChevronDown, {
            className: "h-4 w-4"
          }), _jsx("span", {
            className: "sr-only",
            children: copy.toggleDetails
          })]
        })]
      })]
    }), isExpanded && _jsxs("div", {
      className: "space-y-4 p-4",
      children: [_jsxs("div", {
        className: "grid gap-4 md:grid-cols-2",
        children: [_jsxs("div", {
          className: "space-y-2",
          children: [_jsx("h4", {
            className: "text-sm font-medium",
            children: copy.requestDetails
          }), _jsxs("div", {
            className: "grid grid-cols-2 gap-2 rounded-md border p-3 text-sm",
            children: [_jsx("div", {
              className: "text-muted-foreground",
              children: copy.projectId
            }), _jsx(PlainIdValue, {
              id: log.projectId
            }), _jsx("div", {
              className: "text-muted-foreground",
              children: copy.apiKey
            }), _jsx(PlainIdValue, {
              id: log.apiKeyId
            }), _jsx("div", {
              className: "text-muted-foreground",
              children: copy.requestedModel
            }), _jsx("div", {
              className: "font-mono text-xs break-all",
              children: log.requestedModel
            }), _jsx("div", {
              className: "text-muted-foreground",
              children: copy.usedModel
            }), _jsx("div", {
              className: "font-mono text-xs break-all",
              children: log.usedModel === "" ? "—" : log.usedModel
            }), log.usedModelMapping && _jsxs(_Fragment, {
              children: [_jsx("div", {
                className: "text-muted-foreground",
                children: copy.usedModelProviderMapping
              }), _jsx("div", {
                children: log.usedModelMapping
              })]
            }), _jsx("div", {
              className: "text-muted-foreground",
              children: copy.provider
            }), _jsx("div", {
              children: log.usedProvider
            })]
          }), routingMetadata && _jsxs("div", {
            className: "mt-3",
            children: [_jsx("h5", {
              className: "text-xs font-medium text-muted-foreground mb-2",
              children: copy.routingInfo
            }), _jsxs("div", {
              className: "rounded-md border border-dashed p-2 text-xs space-y-1.5 bg-muted/30",
              children: [routingMetadata.selectionReason && _jsxs("div", {
                className: "flex justify-between",
                children: [_jsx("span", {
                  className: "text-muted-foreground",
                  children: copy.selection
                }), _jsx("span", {
                  className: "font-mono",
                  children: routingMetadata.selectionReason
                })]
              }), routingMetadata.usedApiKeyHash && _jsxs("div", {
                className: "flex justify-between",
                children: [_jsx("span", {
                  className: "text-muted-foreground",
                  children: copy.key
                }), _jsx("span", {
                  className: "font-mono",
                  children: formatApiKeyHash(routingMetadata.usedApiKeyHash)
                })]
              }), routingMetadata.xNoFallbackHeaderSet !== undefined && _jsxs("div", {
                className: "flex justify-between",
                children: [_jsx("span", {
                  className: "text-muted-foreground",
                  children: "X-No-Fallback"
                }), _jsxs("span", {
                  className: "font-mono",
                  children: [routingMetadata.xNoFallbackHeaderSet ? copy.set : copy.unset, routingMetadata.noFallback ? " (".concat(copy.active, ")") : ""]
                })]
              }), routingMetadata.availableProviders && routingMetadata.availableProviders.length > 0 && _jsxs("div", {
                className: "flex justify-between",
                children: [_jsx("span", {
                  className: "text-muted-foreground",
                  children: copy.available
                }), _jsx("span", {
                  className: "font-mono",
                  children: routingMetadata.availableProviders.join(", ")
                })]
              }), routingMetadata.providerScores && routingMetadata.providerScores.length > 0 && _jsxs("div", {
                className: "pt-1 border-t border-dashed",
                children: [_jsx("div", {
                  className: "text-muted-foreground mb-1",
                  children: copy.scores
                }), _jsx("div", {
                  className: "space-y-1",
                  children: routingMetadata.providerScores.map(function (score) {
                    var _a_1, _b_1, _c_0, _d;
                    return _jsxs("div", {
                      className: "flex justify-between items-center",
                      children: [_jsxs("span", {
                        className: "font-mono flex items-center gap-1.5",
                        children: [score.providerId, score.region && _jsxs("span", {
                          className: "text-muted-foreground",
                          children: ["(", score.region, ")"]
                        }), score.failed && _jsxs("span", {
                          className: "inline-flex items-center gap-0.5 text-red-500",
                          children: [_jsx(AlertCircle, {
                            className: "h-3 w-3"
                          }), _jsxs("span", {
                            children: [score.status_code, score.error_type && _jsx("span", {
                              className: "ml-0.5 text-red-400",
                              children: score.error_type
                            })]
                          })]
                        }), score.rate_limited && _jsxs("span", {
                          className: "inline-flex items-center gap-0.5 text-amber-500",
                          children: [_jsx(Clock, {
                            className: "h-3 w-3"
                          }), _jsx("span", {
                            children: copy.rpmCapped
                          })]
                        }), score.excludedByContentFilter && _jsxs("span", {
                          className: "inline-flex items-center gap-0.5 text-amber-500",
                          children: [_jsx(Ban, {
                            className: "h-3 w-3"
                          }), _jsx("span", {
                            children: copy.contentFilter
                          })]
                        })]
                      }), _jsxs("span", {
                        className: "text-muted-foreground font-mono",
                        children: [score.score.toFixed(2), score.uptime !== undefined && _jsxs("span", {
                          className: "ml-2",
                          children: ["\u2191", (_a_1 = score.uptime) === null || _a_1 === void 0 ? void 0 : _a_1.toFixed(0), "%"]
                        }), score.throughput !== undefined && _jsxs("span", {
                          className: "ml-2",
                          children: [(_b_1 = score.throughput) === null || _b_1 === void 0 ? void 0 : _b_1.toFixed(0), "t/s"]
                        }), score.latency !== undefined && _jsxs("span", {
                          className: "ml-2",
                          children: [(_c_0 = score.latency) === null || _c_0 === void 0 ? void 0 : _c_0.toFixed(0), "ms"]
                        }), score.price !== undefined && _jsxs("span", {
                          className: "ml-2",
                          children: ["$", score.price]
                        }), score.priority !== undefined && score.priority !== 1 && _jsxs("span", {
                          className: "ml-2",
                          children: ["p:", score.priority]
                        }), score.cacheSupported && _jsx("span", {
                          className: "ml-2",
                          children: copy.cache
                        })]
                      })]
                    }, "".concat(score.providerId, "-").concat((_d = score.region) !== null && _d !== void 0 ? _d : "default"));
                  })
                })]
              }), routingMetadata.routing && routingMetadata.routing.length > 0 && _jsxs("div", {
                className: "pt-1 border-t border-dashed",
                children: [_jsx("div", {
                  className: "text-muted-foreground mb-1",
                  children: copy.requestAttempts
                }), _jsx("div", {
                  className: "space-y-1",
                  children: routingMetadata.routing.map(function (attempt, i) {
                    return _jsxs("div", {
                      className: "flex justify-between items-center ".concat(attempt.succeeded ? "text-green-600" : "text-red-500"),
                      children: [_jsxs("span", {
                        className: "font-mono flex items-center gap-1",
                        children: [attempt.succeeded ? _jsx(CheckCircle2, {
                          className: "h-3 w-3"
                        }) : _jsx(AlertCircle, {
                          className: "h-3 w-3"
                        }), attempt.provider, "/", attempt.model, attempt.region && _jsxs("span", {
                          className: "text-muted-foreground",
                          children: ["(", attempt.region, ")"]
                        }), attempt.apiKeyHash && _jsxs("span", {
                          className: "text-muted-foreground",
                          children: [copy.key, " ", formatApiKeyHash(attempt.apiKeyHash)]
                        }), attempt.logId && (getDetailUrl ? _jsxs(LinkComponent, {
                          href: getDetailUrl(attempt.logId),
                          className: "text-muted-foreground hover:underline",
                          children: [copy.log, " ", attempt.logId]
                        }) : _jsxs("span", {
                          className: "text-muted-foreground",
                          children: [copy.log, " ", attempt.logId]
                        }))]
                      }), _jsxs("span", {
                        children: [attempt.status_code, " ", attempt.succeeded ? copy.ok : attempt.error_type]
                      })]
                    }, "".concat(attempt.provider, "-").concat(i));
                  })
                })]
              })]
            })]
          })]
        }), _jsxs("div", {
          className: "space-y-2",
          children: [_jsx("h4", {
            className: "text-sm font-medium",
            children: copy.responseMetrics
          }), _jsxs("div", {
            className: "grid grid-cols-2 gap-2 rounded-md border p-3 text-sm",
            children: [_jsx("div", {
              className: "text-muted-foreground",
              children: copy.duration
            }), _jsx("div", {
              children: formatDuration((_d_0 = log.duration) !== null && _d_0 !== void 0 ? _d_0 : 0)
            }), _jsx("div", {
              className: "text-muted-foreground",
              children: copy.throughput
            }), _jsx("div", {
              children: log.duration && log.totalTokens ? "".concat((Number(log.totalTokens) / (log.duration / 1000)).toFixed(1), "t/s") : "-"
            }), log.timeToFirstToken !== null && log.timeToFirstToken !== undefined && _jsxs(_Fragment, {
              children: [_jsx("div", {
                className: "text-muted-foreground",
                children: copy.timeToFirstToken
              }), _jsx("div", {
                children: formatDuration(log.timeToFirstToken)
              })]
            }), log.timeToFirstReasoningToken !== null && log.timeToFirstReasoningToken !== undefined && _jsxs(_Fragment, {
              children: [_jsx("div", {
                className: "text-muted-foreground",
                children: copy.timeToFirstReasoningToken
              }), _jsx("div", {
                children: formatDuration(log.timeToFirstReasoningToken)
              })]
            }), _jsx("div", {
              className: "text-muted-foreground",
              children: copy.responseSize
            }), _jsx("div", {
              children: log.responseSize ? _jsxs(_Fragment, {
                children: [prettyBytes(log.responseSize), " (", log.responseSize, " ", copy.bytes, ")"]
              }) : copy.unknown
            }), _jsx("div", {
              className: "text-muted-foreground",
              children: copy.promptTokens
            }), _jsx("div", {
              children: log.promptTokens
            }), _jsx("div", {
              className: "text-muted-foreground",
              children: copy.completionTokens
            }), _jsx("div", {
              children: log.completionTokens
            }), _jsx("div", {
              className: "text-muted-foreground",
              children: copy.totalTokens
            }), _jsx("div", {
              className: "font-medium",
              children: log.totalTokens
            }), log.cachedTokens && Number(log.cachedTokens) > 0 && _jsxs(_Fragment, {
              children: [_jsx("div", {
                className: "text-muted-foreground",
                children: copy.cachedInputTokens
              }), _jsx("div", {
                className: "font-medium",
                children: log.cachedTokens
              })]
            }), log.cacheWriteTokens && Number(log.cacheWriteTokens) > 0 && _jsxs(_Fragment, {
              children: [_jsx("div", {
                className: "text-muted-foreground",
                children: copy.cacheWriteTokens
              }), _jsx("div", {
                className: "font-medium",
                children: log.cacheWriteTokens
              })]
            }), log.reasoningTokens && Number(log.reasoningTokens) > 0 && _jsxs(_Fragment, {
              children: [_jsx("div", {
                className: "text-muted-foreground",
                children: copy.reasoningTokens
              }), _jsx("div", {
                children: log.reasoningTokens
              })]
            }), log.imageInputTokens && Number(log.imageInputTokens) > 0 && _jsxs(_Fragment, {
              children: [_jsx("div", {
                className: "text-muted-foreground",
                children: copy.imageInputTokens
              }), _jsx("div", {
                children: log.imageInputTokens
              })]
            }), log.imageOutputTokens && Number(log.imageOutputTokens) > 0 && _jsxs(_Fragment, {
              children: [_jsx("div", {
                className: "text-muted-foreground",
                children: copy.imageOutputTokens
              }), _jsx("div", {
                children: log.imageOutputTokens
              })]
            }), log.audioInputTokens && Number(log.audioInputTokens) > 0 && _jsxs(_Fragment, {
              children: [_jsx("div", {
                className: "text-muted-foreground",
                children: copy.audioInputTokens
              }), _jsx("div", {
                children: log.audioInputTokens
              })]
            }), _jsx("div", {
              className: "text-muted-foreground",
              children: copy.originalFinishReason
            }), _jsx("div", {
              children: copy.finishReason(log.finishReason)
            }), _jsx("div", {
              className: "text-muted-foreground",
              children: copy.unifiedFinishReason
            }), _jsx("div", {
              children: copy.finishReason(log.unifiedFinishReason)
            }), _jsx("div", {
              className: "text-muted-foreground",
              children: copy.streamed
            }), _jsx("div", {
              className: "flex items-center gap-1",
              children: log.streamed ? _jsxs(_Fragment, {
                children: [_jsx(AudioWaveform, {
                  className: "h-3.5 w-3.5 text-green-500"
                }), _jsx("span", {
                  children: copy.yes
                })]
              }) : _jsx("span", {
                children: copy.no
              })
            }), _jsx("div", {
              className: "text-muted-foreground",
              children: copy.canceled
            }), _jsx("div", {
              className: "flex items-center gap-1",
              children: log.canceled ? _jsxs(_Fragment, {
                children: [_jsx(Ban, {
                  className: "h-3.5 w-3.5 text-amber-500"
                }), _jsx("span", {
                  children: copy.yes
                })]
              }) : _jsx("span", {
                children: copy.no
              })
            }), _jsx("div", {
              className: "text-muted-foreground",
              children: copy.cached
            }), _jsx("div", {
              className: "flex items-center gap-1",
              children: log.cached ? _jsxs(_Fragment, {
                children: [_jsx(Zap, {
                  className: "h-3.5 w-3.5 text-blue-500"
                }), _jsx("span", {
                  children: copy.yes
                })]
              }) : _jsx("span", {
                children: copy.no
              })
            })]
          })]
        })]
      }), _jsxs("div", {
        className: "grid gap-4 md:grid-cols-2",
        children: [_jsxs("div", {
          className: "space-y-3",
          children: [_jsx("h4", {
            className: "text-sm font-medium",
            children: copy.costInformation
          }), _jsxs("div", {
            className: "rounded-md border p-3 space-y-3",
            children: [_jsxs("div", {
              children: [_jsxs("p", {
                className: "text-xs text-muted-foreground mb-2",
                children: [copy.providerPricing, log.usedMode === "api-keys" && (isUserFacing ? copy.notDeductedFromYourBalance : copy.notDeductedFromBalance)]
              }), _jsxs("div", {
                className: "grid grid-cols-2 gap-2 text-sm text-muted-foreground",
                children: [_jsx("div", {
                  children: copy.inputCost
                }), _jsx("div", {
                  children: log.inputCost ? "$".concat(log.inputCost.toFixed(8)) : "$0"
                }), _jsx("div", {
                  children: copy.outputCost
                }), _jsx("div", {
                  children: log.outputCost ? "$".concat(log.outputCost.toFixed(8)) : "$0"
                }), !!log.cachedInputCost && Number(log.cachedInputCost) > 0 && _jsxs(_Fragment, {
                  children: [_jsx("div", {
                    children: copy.cachedInputCost
                  }), _jsx("div", {
                    children: "$".concat(Number(log.cachedInputCost).toFixed(8))
                  })]
                }), !!log.cacheWriteInputCost && Number(log.cacheWriteInputCost) > 0 && _jsxs(_Fragment, {
                  children: [_jsx("div", {
                    children: copy.cacheWriteCost
                  }), _jsx("div", {
                    children: "$".concat(Number(log.cacheWriteInputCost).toFixed(8))
                  })]
                }), _jsx("div", {
                  children: copy.requestCost
                }), _jsx("div", {
                  children: log.requestCost ? "$".concat(log.requestCost.toFixed(8)) : "$0"
                }), !!log.webSearchCost && Number(log.webSearchCost) > 0 && _jsxs(_Fragment, {
                  children: [_jsx("div", {
                    children: copy.nativeWebSearchCost
                  }), _jsx("div", {
                    children: "$".concat(Number(log.webSearchCost).toFixed(8))
                  })]
                }), !!log.contentFilterCost && Number(log.contentFilterCost) > 0 && _jsxs(_Fragment, {
                  children: [_jsx("div", {
                    children: copy.contentFilterCost
                  }), _jsx("div", {
                    children: "$".concat(Number(log.contentFilterCost).toFixed(8))
                  })]
                }), !!log.imageInputCost && Number(log.imageInputCost) > 0 && _jsxs(_Fragment, {
                  children: [_jsx("div", {
                    children: copy.imageInputCost
                  }), _jsx("div", {
                    children: "$".concat(Number(log.imageInputCost).toFixed(8))
                  })]
                }), !!log.imageOutputCost && Number(log.imageOutputCost) > 0 && _jsxs(_Fragment, {
                  children: [_jsx("div", {
                    children: copy.imageOutputCost
                  }), _jsx("div", {
                    children: "$".concat(Number(log.imageOutputCost).toFixed(8))
                  })]
                }), !!log.videoOutputCost && Number(log.videoOutputCost) > 0 && _jsxs(_Fragment, {
                  children: [_jsx("div", {
                    children: copy.videoOutputCost
                  }), _jsx("div", {
                    children: "$".concat(Number(log.videoOutputCost).toFixed(8))
                  })]
                }), !!log.audioInputCost && Number(log.audioInputCost) > 0 && _jsxs(_Fragment, {
                  children: [_jsx("div", {
                    children: copy.audioInputCost
                  }), _jsx("div", {
                    children: "$".concat(Number(log.audioInputCost).toFixed(8))
                  })]
                }), _jsx("div", {
                  children: copy.inferenceTotal
                }), _jsx("div", {
                  children: log.cost ? "$".concat(log.cost.toFixed(8)) : "$0"
                }), log.discount && log.discount !== 1 && _jsxs(_Fragment, {
                  children: [_jsx("div", {
                    children: copy.discountApplied
                  }), _jsx("div", {
                    className: "text-green-600",
                    children: copy.discountOff((log.discount * 100).toFixed(0))
                  })]
                }), log.pricingTier && _jsxs(_Fragment, {
                  children: [_jsx("div", {
                    children: copy.pricingTier
                  }), _jsx("div", {
                    children: log.pricingTier
                  })]
                }), log.serviceTier && _jsxs(_Fragment, {
                  children: [_jsx("div", {
                    children: copy.serviceTier
                  }), _jsxs("div", {
                    children: [_jsx("span", {
                      className: "capitalize",
                      children: log.serviceTier
                    }), function () {
                      var _a;
                      var tier = getServiceTier((_a = log.usedProvider) !== null && _a !== void 0 ? _a : "", log.serviceTier);
                      return tier ? _jsxs("span", {
                        className: "ml-1 text-muted-foreground",
                        children: ["(", formatServiceTierMultiplier(tier.multiplier), ")"]
                      }) : null;
                    }()]
                  })]
                })]
              })]
            }), _jsxs("div", {
              className: "border-t pt-3",
              children: [_jsx("p", {
                className: "text-xs font-medium mb-2",
                children: isUserFacing ? copy.billedToYourOrganization : copy.billedToOrganization
              }), _jsxs("div", {
                className: "grid grid-cols-2 gap-2 text-sm",
                children: [_jsx("div", {
                  className: "text-muted-foreground",
                  children: copy.dataStorage
                }), _jsx("div", {
                  className: "font-medium",
                  children: log.dataStorageCost ? "$".concat(Number(log.dataStorageCost).toFixed(8)) : "$0"
                })]
              })]
            })]
          })]
        }), _jsxs("div", {
          className: "space-y-2",
          children: [_jsx("h4", {
            className: "text-sm font-medium",
            children: copy.metadata
          }), _jsxs("div", {
            className: "grid grid-cols-2 gap-2 rounded-md border p-3 text-sm",
            children: [_jsx("div", {
              className: "text-muted-foreground",
              children: copy.date
            }), _jsx("div", {
              className: "font-mono text-xs",
              children: format(new Date(log.createdAt), copy.dateFormat, {
                locale: dateFnsLocale
              })
            }), _jsx("div", {
              className: "text-muted-foreground",
              children: copy.requestId
            }), _jsxs("div", {
              className: "flex items-center gap-1 font-mono text-xs break-all",
              children: [_jsx("span", {
                children: (_e = log.requestId) !== null && _e !== void 0 ? _e : "—"
              }), showCopyButtons && log.requestId && _jsx(CopyMetadataButton, {
                value: log.requestId,
                label: copy.copyRequestId,
                copiedLabel: copy.copied
              })]
            }), _jsx("div", {
              className: "text-muted-foreground",
              children: copy.traceId
            }), _jsxs("div", {
              className: "flex items-center gap-1 font-mono text-xs break-all",
              children: [_jsx("span", {
                children: (_f = log.traceId) !== null && _f !== void 0 ? _f : "—"
              }), showCopyButtons && log.traceId && _jsx(CopyMetadataButton, {
                value: log.traceId,
                label: copy.copyTraceId,
                copiedLabel: copy.copied
              })]
            }), _jsx("div", {
              className: "text-muted-foreground",
              children: copy.sessionId
            }), _jsxs("div", {
              className: "flex items-center gap-1 font-mono text-xs break-all",
              children: [_jsx("span", {
                children: (_g = log.sessionId) !== null && _g !== void 0 ? _g : "—"
              }), showCopyButtons && log.sessionId && _jsx(CopyMetadataButton, {
                value: log.sessionId,
                label: copy.copySessionId,
                copiedLabel: copy.copied
              })]
            }), showLogId && _jsxs(_Fragment, {
              children: [_jsx("div", {
                className: "text-muted-foreground",
                children: copy.logId
              }), _jsxs("div", {
                className: "flex items-center gap-1 font-mono text-xs break-all",
                children: [_jsx("span", {
                  children: log.id
                }), showCopyButtons && _jsx(CopyMetadataButton, {
                  value: log.id,
                  label: copy.copyLogId,
                  copiedLabel: copy.copied
                })]
              })]
            }), _jsx("div", {
              className: "text-muted-foreground",
              children: copy.source
            }), _jsx("div", {
              className: "font-mono text-xs break-all",
              children: (_h = log.source) !== null && _h !== void 0 ? _h : "-"
            }), log.userAgent && _jsxs(_Fragment, {
              children: [_jsx("div", {
                className: "text-muted-foreground",
                children: copy.userAgent
              }), _jsx("div", {
                className: "font-mono text-xs break-all",
                children: log.userAgent
              })]
            }), _jsx("div", {
              className: "text-muted-foreground",
              children: copy.project
            }), _jsx(RelatedResourceValue, {
              id: log.projectId,
              name: log.projectName,
              copyLabel: copy.copyProjectId,
              copiedLabel: copy.copied,
              showCopyButton: showCopyButtons
            }), _jsx("div", {
              className: "text-muted-foreground",
              children: copy.organization
            }), _jsx(RelatedResourceValue, {
              id: log.organizationId,
              name: log.organizationName,
              copyLabel: copy.copyOrganizationId,
              copiedLabel: copy.copied,
              showCopyButton: showCopyButtons
            }), _jsx("div", {
              className: "text-muted-foreground",
              children: copy.apiKey
            }), _jsx(RelatedResourceValue, {
              id: log.apiKeyId,
              name: log.apiKeyName,
              copyLabel: copy.copyApiKeyId,
              copiedLabel: copy.copied,
              showCopyButton: showCopyButtons
            }), _jsx("div", {
              className: "text-muted-foreground",
              children: copy.mode
            }), _jsx("div", {
              children: (_j = log.mode) !== null && _j !== void 0 ? _j : "?"
            }), _jsx("div", {
              className: "text-muted-foreground",
              children: copy.usedMode
            }), _jsx("div", {
              children: (_k = log.usedMode) !== null && _k !== void 0 ? _k : "?"
            })]
          }), customHeaders && Object.keys(customHeaders).length > 0 && _jsxs("div", {
            className: "mt-3",
            children: [_jsx("h5", {
              className: "text-xs font-medium text-muted-foreground mb-2",
              children: copy.customHeaders
            }), _jsx("div", {
              className: "rounded-md border p-3",
              children: _jsx("div", {
                className: "grid grid-cols-2 gap-2 text-sm",
                children: Object.entries(customHeaders).map(function (_a_2) {
                  var key = _a_2[0],
                    value = _a_2[1];
                  return _jsxs("div", {
                    className: "contents",
                    children: [_jsx("div", {
                      className: "text-muted-foreground font-mono text-xs",
                      children: key
                    }), _jsx("div", {
                      className: "font-mono text-xs break-words",
                      children: String(value)
                    })]
                  }, key);
                })
              })
            })]
          })]
        })]
      }), _jsxs("div", {
        className: "space-y-2",
        children: [_jsx("h4", {
          className: "text-sm font-medium",
          children: copy.modelParameters
        }), _jsxs("div", {
          className: "grid gap-2 rounded-md border p-3 text-sm sm:grid-cols-2 md:grid-cols-4",
          children: [_jsxs("div", {
            className: "flex items-center justify-between gap-2",
            children: [_jsxs(Tooltip, {
              children: [_jsx(TooltipTrigger, {
                asChild: true,
                children: _jsx("span", {
                  className: "text-muted-foreground",
                  children: copy.temperature
                })
              }), _jsx(TooltipContent, {
                children: _jsx("p", {
                  className: "max-w-xs text-xs",
                  children: copy.temperatureDescription
                })
              })]
            }), _jsx("span", {
              children: log.temperature
            })]
          }), _jsxs("div", {
            className: "flex items-center justify-between gap-2",
            children: [_jsxs(Tooltip, {
              children: [_jsx(TooltipTrigger, {
                asChild: true,
                children: _jsx("span", {
                  className: "text-muted-foreground",
                  children: copy.maxTokens
                })
              }), _jsx(TooltipContent, {
                children: _jsx("p", {
                  className: "max-w-xs text-xs",
                  children: copy.maxTokensDescription
                })
              })]
            }), _jsx("span", {
              children: log.maxTokens
            })]
          }), _jsxs("div", {
            className: "flex items-center justify-between gap-2",
            children: [_jsxs(Tooltip, {
              children: [_jsx(TooltipTrigger, {
                asChild: true,
                children: _jsx("span", {
                  className: "text-muted-foreground",
                  children: copy.topP
                })
              }), _jsx(TooltipContent, {
                children: _jsx("p", {
                  className: "max-w-xs text-xs",
                  children: copy.topPDescription
                })
              })]
            }), _jsx("span", {
              children: log.topP
            })]
          }), _jsxs("div", {
            className: "flex items-center justify-between gap-2",
            children: [_jsxs(Tooltip, {
              children: [_jsx(TooltipTrigger, {
                asChild: true,
                children: _jsx("span", {
                  className: "text-muted-foreground",
                  children: copy.frequencyPenalty
                })
              }), _jsx(TooltipContent, {
                children: _jsx("p", {
                  className: "max-w-xs text-xs",
                  children: copy.frequencyPenaltyDescription
                })
              })]
            }), _jsx("span", {
              children: log.frequencyPenalty
            })]
          }), _jsxs("div", {
            className: "flex items-center justify-between gap-2",
            children: [_jsxs(Tooltip, {
              children: [_jsx(TooltipTrigger, {
                asChild: true,
                children: _jsx("span", {
                  className: "text-muted-foreground",
                  children: copy.reasoningEffort
                })
              }), _jsx(TooltipContent, {
                children: _jsx("p", {
                  className: "max-w-xs text-xs",
                  children: copy.reasoningEffortDescription
                })
              })]
            }), _jsx("span", {
              children: (_l = log.reasoningEffort) !== null && _l !== void 0 ? _l : "-"
            })]
          }), log.reasoningMaxTokens && _jsxs("div", {
            className: "flex items-center justify-between gap-2",
            children: [_jsxs(Tooltip, {
              children: [_jsx(TooltipTrigger, {
                asChild: true,
                children: _jsx("span", {
                  className: "text-muted-foreground",
                  children: copy.reasoningBudget
                })
              }), _jsx(TooltipContent, {
                children: _jsx("p", {
                  className: "max-w-xs text-xs",
                  children: copy.reasoningBudgetDescription
                })
              })]
            }), _jsx("span", {
              children: log.reasoningMaxTokens.toLocaleString()
            })]
          }), log.effort && _jsxs("div", {
            className: "flex items-center justify-between gap-2",
            children: [_jsxs(Tooltip, {
              children: [_jsx(TooltipTrigger, {
                asChild: true,
                children: _jsx("span", {
                  className: "text-muted-foreground",
                  children: copy.effort
                })
              }), _jsx(TooltipContent, {
                children: _jsx("p", {
                  className: "max-w-xs text-xs",
                  children: copy.effortDescription
                })
              })]
            }), _jsx("span", {
              children: log.effort
            })]
          }), _jsxs("div", {
            className: "flex items-center justify-between gap-2",
            children: [_jsxs(Tooltip, {
              children: [_jsx(TooltipTrigger, {
                asChild: true,
                children: _jsx("span", {
                  className: "text-muted-foreground",
                  children: copy.responseFormat
                })
              }), _jsx(TooltipContent, {
                children: _jsx("p", {
                  className: "max-w-xs text-xs",
                  children: copy.responseFormatDescription
                })
              })]
            }), _jsx("span", {
              children: responseFormat ? typeof responseFormat === "object" ? (_m = responseFormat.type) !== null && _m !== void 0 ? _m : "-" : "-" : "-"
            })]
          }), (imageConfig === null || imageConfig === void 0 ? void 0 : imageConfig.aspect_ratio) && _jsxs("div", {
            className: "flex items-center justify-between gap-2",
            children: [_jsx("span", {
              className: "text-muted-foreground",
              children: copy.aspectRatio
            }), _jsx("span", {
              children: String(imageConfig.aspect_ratio)
            })]
          }), (imageConfig === null || imageConfig === void 0 ? void 0 : imageConfig.image_size) && _jsxs("div", {
            className: "flex items-center justify-between gap-2",
            children: [_jsx("span", {
              className: "text-muted-foreground",
              children: copy.imageSize
            }), _jsx("span", {
              children: String(imageConfig.image_size)
            })]
          }), (imageConfig === null || imageConfig === void 0 ? void 0 : imageConfig.image_quality) && _jsxs("div", {
            className: "flex items-center justify-between gap-2",
            children: [_jsx("span", {
              className: "text-muted-foreground",
              children: copy.imageQuality
            }), _jsx("span", {
              children: String(imageConfig.image_quality)
            })]
          }), (imageConfig === null || imageConfig === void 0 ? void 0 : imageConfig.n) !== undefined && imageConfig.n !== null && _jsxs("div", {
            className: "flex items-center justify-between gap-2",
            children: [_jsx("span", {
              className: "text-muted-foreground",
              children: copy.imageCount
            }), _jsx("span", {
              children: String(imageConfig.n)
            })]
          }), (imageConfig === null || imageConfig === void 0 ? void 0 : imageConfig.output_format) && _jsxs("div", {
            className: "flex items-center justify-between gap-2",
            children: [_jsx("span", {
              className: "text-muted-foreground",
              children: copy.outputFormat
            }), _jsx("span", {
              children: String(imageConfig.output_format)
            })]
          }), (imageConfig === null || imageConfig === void 0 ? void 0 : imageConfig.output_compression) !== undefined && imageConfig.output_compression !== null && _jsxs("div", {
            className: "flex items-center justify-between gap-2",
            children: [_jsx("span", {
              className: "text-muted-foreground",
              children: copy.compression
            }), _jsx("span", {
              children: String(imageConfig.output_compression)
            })]
          }), (imageConfig === null || imageConfig === void 0 ? void 0 : imageConfig.seed) !== undefined && imageConfig.seed !== null && _jsxs("div", {
            className: "flex items-center justify-between gap-2",
            children: [_jsx("span", {
              className: "text-muted-foreground",
              children: copy.seed
            }), _jsx("span", {
              children: String(imageConfig.seed)
            })]
          })]
        })]
      }), log.plugins && log.plugins.length > 0 && _jsxs("div", {
        className: "space-y-2",
        children: [_jsx("h4", {
          className: "text-sm font-medium",
          children: copy.plugins
        }), _jsxs("div", {
          className: "rounded-md border p-3 text-sm space-y-3",
          children: [_jsx("div", {
            className: "flex flex-wrap gap-2",
            children: log.plugins.map(function (plugin) {
              return _jsxs(Badge, {
                variant: "secondary",
                className: "gap-1",
                children: [_jsx(Plug, {
                  className: "h-3 w-3"
                }), plugin]
              }, plugin);
            })
          }), pluginResults && _jsxs("div", {
            className: "space-y-2 pt-2 border-t",
            children: [_jsx("h5", {
              className: "text-xs font-medium text-muted-foreground",
              children: copy.pluginResults
            }), pluginResults.responseHealing && _jsxs("div", {
              className: "flex items-center gap-2 text-xs",
              children: [_jsx(Sparkles, {
                className: "h-3.5 w-3.5 ".concat(pluginResults.responseHealing.healed ? "text-green-500" : "text-muted-foreground")
              }), _jsxs("span", {
                children: [copy.responseHealing, " ", pluginResults.responseHealing.healed ? _jsxs("span", {
                  className: "text-green-600 font-medium",
                  children: [copy.applied, pluginResults.responseHealing.healingMethod && _jsxs("span", {
                    className: "text-muted-foreground font-normal",
                    children: [" ", "(", pluginResults.responseHealing.healingMethod.replace(/_/g, " ").replace(/\b\w/g, function (l) {
                      return l.toUpperCase();
                    }), ")"]
                  })]
                }) : _jsx("span", {
                  className: "text-muted-foreground",
                  children: copy.notNeededValidJson
                })]
              })]
            })]
          })]
        })]
      }), remainingParams && Object.keys(remainingParams).length > 0 && _jsxs("div", {
        className: "space-y-2",
        children: [_jsx("h4", {
          className: "text-sm font-medium",
          children: copy.additionalParameters
        }), _jsx("div", {
          className: "grid grid-cols-2 gap-2 rounded-md border p-3 text-sm",
          children: renderParams(remainingParams)
        })]
      }), ((_o = tools !== null && tools !== void 0 ? tools : toolChoice) !== null && _o !== void 0 ? _o : toolResults) && _jsxs("div", {
        className: "space-y-2",
        children: [_jsx("h4", {
          className: "text-sm font-medium",
          children: copy.toolInformation
        }), _jsxs("div", {
          className: "grid gap-4 md:grid-cols-1",
          children: [tools && _jsxs("div", {
            className: "space-y-2",
            children: [_jsx("h5", {
              className: "text-xs font-medium text-muted-foreground",
              children: copy.availableTools
            }), _jsx("div", {
              className: "rounded-md border p-3",
              children: _jsx("pre", {
                className: "max-h-40 text-xs overflow-auto whitespace-pre-wrap break-all",
                children: JSON.stringify(tools, null, 2)
              })
            })]
          }), toolChoice && _jsxs("div", {
            className: "space-y-2",
            children: [_jsx("h5", {
              className: "text-xs font-medium text-muted-foreground",
              children: copy.toolChoice
            }), _jsx("div", {
              className: "rounded-md border p-3",
              children: _jsx("pre", {
                className: "max-h-40 text-xs overflow-auto whitespace-pre-wrap break-all",
                children: JSON.stringify(toolChoice, null, 2)
              })
            })]
          }), toolResults && _jsxs("div", {
            className: "space-y-2",
            children: [_jsx("h5", {
              className: "text-xs font-medium text-muted-foreground",
              children: copy.toolCallsTitle
            }), _jsx("div", {
              className: "space-y-2",
              children: Array.isArray(toolResults) ? toolResults.filter(function (tc) {
                return tc !== null && tc !== undefined;
              }).map(function (toolCall, index) {
                var _a_3, _b_2, _c_1, _d_1;
                return _jsx("div", {
                  className: "rounded-md border p-3 overflow-scroll",
                  children: _jsxs("div", {
                    className: "grid gap-2 text-xs",
                    children: [_jsxs("div", {
                      className: "flex justify-between",
                      children: [_jsx("span", {
                        className: "font-medium",
                        children: (_b_2 = (_a_3 = toolCall.function) === null || _a_3 === void 0 ? void 0 : _a_3.name) !== null && _b_2 !== void 0 ? _b_2 : copy.unknownFunction
                      }), _jsxs("span", {
                        className: "text-muted-foreground",
                        children: [copy.idLabel, ":", " ", (_c_1 = toolCall.id) !== null && _c_1 !== void 0 ? _c_1 : copy.notAvailable]
                      })]
                    }), ((_d_1 = toolCall.function) === null || _d_1 === void 0 ? void 0 : _d_1.arguments) && _jsxs("div", {
                      className: "space-y-1",
                      children: [_jsx("div", {
                        className: "text-muted-foreground",
                        children: copy.arguments
                      }), _jsx("pre", {
                        className: "text-xs bg-white dark:bg-gray-900 rounded border p-2 overflow-auto max-h-32 text-wrap",
                        children: typeof toolCall.function.arguments === "string" ? toolCall.function.arguments : JSON.stringify(toolCall.function.arguments, null, 2)
                      })]
                    })]
                  })
                }, index);
              }) : _jsx("div", {
                className: "rounded-md border p-3",
                children: _jsx("pre", {
                  className: "max-h-40 text-xs overflow-auto whitespace-pre-wrap break-all",
                  children: JSON.stringify(toolResults, null, 2)
                })
              })
            })]
          })]
        })]
      }), !!log.webSearchCost && Number(log.webSearchCost) > 0 && _jsxs("div", {
        className: "space-y-2",
        children: [_jsx("h4", {
          className: "text-sm font-medium",
          children: copy.builtinTools
        }), _jsx("div", {
          className: "grid gap-4 md:grid-cols-1",
          children: _jsxs("div", {
            className: "space-y-2",
            children: [_jsx("h5", {
              className: "text-xs font-medium text-muted-foreground",
              children: copy.nativeWebSearch
            }), _jsx("div", {
              className: "rounded-md border p-3",
              children: _jsxs("div", {
                className: "flex items-center gap-2 text-sm",
                children: [_jsx(Globe, {
                  className: "h-4 w-4 text-sky-500"
                }), _jsx("span", {
                  children: copy.webSearchUsed
                }), _jsxs("span", {
                  className: "ml-auto text-muted-foreground",
                  children: [copy.cost, ": $", Number(log.webSearchCost).toFixed(4)]
                })]
              })
            })]
          })
        })]
      }), log.hasError && !!errorDetails && _jsxs("div", {
        className: "space-y-2",
        children: [_jsx("h4", {
          className: "text-sm font-medium text-red-600",
          children: copy.errorDetails
        }), _jsxs("div", {
          className: "grid grid-cols-2 gap-2 rounded-md border border-red-200 dark:border-red-800 bg-red-50 dark:bg-red-900/30 p-3 text-sm",
          children: [_jsx("div", {
            className: "text-red-600",
            children: copy.statusCode
          }), _jsx("div", {
            className: "font-medium",
            children: errorDetails.statusCode
          }), _jsx("div", {
            className: "text-red-600",
            children: copy.statusText
          }), _jsx("div", {
            className: "font-medium",
            children: errorDetails.statusText
          }), _jsx("div", {
            className: "text-red-600 col-span-2",
            children: copy.errorMessage
          }), _jsx("div", {
            className: "col-span-2 rounded bg-white dark:bg-gray-900 text-black dark:text-gray-100 p-2 text-xs",
            children: errorDetails.responseText
          })]
        }), log.retried && log.retriedByLogId && _jsxs("div", {
          className: "flex items-center gap-2 rounded-md border border-amber-200 dark:border-amber-700 bg-amber-50 dark:bg-amber-900/30 p-3 text-sm",
          children: [_jsx(RefreshCw, {
            className: "h-4 w-4 text-amber-600"
          }), _jsx("span", {
            className: "text-amber-800",
            children: copy.requestRetriedSucceeded
          }), getRetriedUrl ? _jsx(LinkComponent, {
            href: getRetriedUrl(log.retriedByLogId),
            className: "text-amber-600 underline hover:text-amber-800 ml-auto",
            children: copy.viewSuccessfulRequest
          }) : _jsx("span", {
            className: "text-amber-600 ml-auto font-mono text-xs",
            children: log.retriedByLogId
          })]
        })]
      }), _jsxs("div", {
        className: "space-y-2",
        children: [_jsxs("div", {
          className: "flex items-center justify-between",
          children: [_jsx("h4", {
            className: "text-sm font-medium",
            children: copy.messageContext
          }), messagesHaveRedactedInput && fetchInputImages && _jsxs(Button, {
            variant: "outline",
            size: "sm",
            className: "h-7 gap-1.5 text-xs",
            disabled: inputPreviewLoading,
            onClick: function () {
              return __awaiter(_this, void 0, void 0, function () {
                var srcs;
                return __generator(this, function (_a_4) {
                  switch (_a_4.label) {
                    case 0:
                      setInputPreviewLoading(true);
                      _a_4.label = 1;
                    case 1:
                      _a_4.trys.push([1,, 3, 4]);
                      return [4, fetchInputImages(log.id)];
                    case 2:
                      srcs = _a_4.sent();
                      if (srcs && srcs.length > 0) {
                        setImagePreviewSrcs(srcs);
                        setImagePreviewTitle(copy.inputImageTitle);
                        setImagePreviewOpen(true);
                      }
                      return [3, 4];
                    case 3:
                      setInputPreviewLoading(false);
                      return [7];
                    case 4:
                      return [2];
                  }
                });
              });
            },
            children: [inputPreviewLoading ? _jsx(Loader2, {
              className: "h-3.5 w-3.5 animate-spin"
            }) : _jsx(Eye, {
              className: "h-3.5 w-3.5"
            }), copy.previewInput]
          })]
        }), _jsx("div", {
          className: "rounded-md border p-3",
          children: messages ? _jsx("pre", {
            className: "max-h-60 text-xs overflow-auto whitespace-pre-wrap break-all",
            children: JSON.stringify(messages, function (_key, value_0) {
              if (typeof value_0 === "string" && value_0.length > 200 && /[A-Za-z0-9+/]{200,}/.test(value_0)) {
                return copy.base64ImageData;
              }
              return value_0;
            }, 2)
          }) : !retentionEnabled && isUserFacing ? _jsx("p", {
            className: "text-sm text-muted-foreground italic",
            children: copy.messageDataNotRetained
          }) : _jsx("p", {
            className: "text-sm text-muted-foreground italic",
            children: copy.noMessageData
          })
        }), !!responseFormat && _jsxs("div", {
          className: "mt-3",
          children: [_jsx("h5", {
            className: "text-xs font-medium text-muted-foreground mb-2",
            children: copy.responseFormat
          }), _jsx("div", {
            className: "rounded-md border p-3",
            children: _jsx("pre", {
              className: "max-h-40 text-xs overflow-auto whitespace-pre-wrap break-all",
              children: JSON.stringify(responseFormat, null, 2)
            })
          })]
        })]
      }), log.reasoningContent && _jsxs("div", {
        className: "space-y-2",
        children: [_jsx("h4", {
          className: "text-sm font-medium",
          children: copy.reasoningContent
        }), _jsx("div", {
          className: "rounded-md border p-3",
          children: _jsx("pre", {
            className: "max-h-60 text-xs overflow-auto whitespace-pre-wrap break-all",
            children: log.reasoningContent
          })
        })]
      }), _jsxs("div", {
        className: "space-y-2",
        children: [_jsxs("div", {
          className: "flex items-center justify-between",
          children: [_jsx("h4", {
            className: "text-sm font-medium",
            children: copy.response
          }), log.content === "[image_generated]" && fetchImageContent && _jsxs(Button, {
            variant: "outline",
            size: "sm",
            className: "h-7 gap-1.5 text-xs",
            disabled: imagePreviewLoading,
            onClick: function () {
              return __awaiter(_this, void 0, void 0, function () {
                var content, dataUrlRegex, matches, fmt, mime;
                return __generator(this, function (_a_5) {
                  switch (_a_5.label) {
                    case 0:
                      setImagePreviewLoading(true);
                      _a_5.label = 1;
                    case 1:
                      _a_5.trys.push([1,, 3, 4]);
                      return [4, fetchImageContent(log.id)];
                    case 2:
                      content = _a_5.sent();
                      if (content) {
                        dataUrlRegex = /data:image\/[a-zA-Z0-9.+-]+;base64,[A-Za-z0-9+/=]+/g;
                        matches = content.match(dataUrlRegex);
                        if (matches && matches.length > 0) {
                          setImagePreviewSrcs(matches);
                        } else if (content.startsWith("data:")) {
                          setImagePreviewSrcs([content]);
                        } else {
                          fmt = (imageConfig === null || imageConfig === void 0 ? void 0 : imageConfig.output_format) ? String(imageConfig.output_format).toLowerCase() : "png";
                          mime = "image/".concat(fmt === "jpg" ? "jpeg" : fmt);
                          setImagePreviewSrcs(["data:".concat(mime, ";base64,").concat(content)]);
                        }
                        setImagePreviewTitle(copy.generatedImageTitle);
                        setImagePreviewOpen(true);
                      }
                      return [3, 4];
                    case 3:
                      setImagePreviewLoading(false);
                      return [7];
                    case 4:
                      return [2];
                  }
                });
              });
            },
            children: [imagePreviewLoading ? _jsx(Loader2, {
              className: "h-3.5 w-3.5 animate-spin"
            }) : _jsx(Eye, {
              className: "h-3.5 w-3.5"
            }), copy.previewImage]
          })]
        }), _jsx("div", {
          className: "rounded-md border p-3",
          children: log.content === "[image_generated]" ? _jsxs("div", {
            className: "flex items-center gap-2 text-sm text-muted-foreground",
            children: [_jsx(Sparkles, {
              className: "h-4 w-4"
            }), _jsx("span", {
              children: copy.imageGeneratedSentence
            }), detailUrl && _jsx(LinkComponent, {
              href: detailUrl,
              className: "text-blue-600 dark:text-blue-400 hover:underline",
              children: copy.viewImage
            })]
          }) : log.content ? _jsx("pre", {
            className: "max-h-60 text-xs overflow-auto whitespace-pre-wrap break-all",
            children: log.content
          }) : !retentionEnabled && isUserFacing ? _jsx("p", {
            className: "text-sm text-muted-foreground italic",
            children: copy.responseContentNotRetained
          }) : _jsx("p", {
            className: "text-sm text-muted-foreground italic",
            children: copy.noResponseContent
          })
        })]
      })]
    }), _jsx(Dialog, {
      open: imagePreviewOpen,
      onOpenChange: setImagePreviewOpen,
      children: _jsxs(DialogContent, {
        className: "max-w-2xl",
        children: [_jsxs(DialogHeader, {
          children: [_jsx(DialogTitle, {
            children: imagePreviewTitle
          }), _jsx(DialogDescription, {
            children: copy.previewOfImages(imagePreviewTitle, imagePreviewSrcs.length)
          })]
        }), imagePreviewSrcs.length > 0 && _jsx("div", {
          className: "grid gap-4 grid-cols-1 sm:grid-cols-2",
          children: imagePreviewSrcs.map(function (src, i_0) {
            return _jsx("div", {
              className: "rounded-md border overflow-hidden",
              children: _jsx("img", {
                src: src,
                alt: copy.imageAlt(i_0 + 1),
                className: "w-full h-auto"
              })
            }, i_0);
          })
        })]
      })
    })]
  });
}